module.exports = __webpack_public_path__ + "static/img/coupons-40.30a85ef1.png";